// extracted by mini-css-extract-plugin
module.exports = {"margin":"style__margin__7zn2c","filterBlock":"style__filterBlock__OZojP","isFilter":"style__isFilter__Bnid6","cleanButton":"style__cleanButton__jHg6G"};